var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card dashboard-card",class:'dashboard-panel-'+_vm.panelSize},[(_vm.error)?_c('div',{staticClass:"card-body d-flex justify-content-center"},[_vm._v("\n    "+_vm._s(_vm.errorMessageDisplayed)+"\n  ")]):_c('div',{staticClass:"card-body",class:_vm.backgroundClass},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }